import React from 'react'
import cx from 'classnames'
import { BtnV2, Icon, Lozenge, l } from '@manychat/manyui'

import cm from 'apps/aiAutomation/components/AiTitle/styles.module.css'
import Title from 'common/core/components/Title/Title'
import { useMediaQuery } from 'utils/commonHooks'
import { typedRouting } from 'utils/router'

export const AiTitle = () => {
  const isMobile = useMediaQuery('(width <= 510px)')

  const navigate = typedRouting.useNavigate()

  return (
    <Title
      theme={{
        main: cm.pageTitle,
      }}
      button={
        <BtnV2
          size="small"
          leftIcon={!isMobile ? 'Ai' : undefined}
          className={cm.testAiButton}
          onClick={() => navigate.aiPlayground()}
        >
          {l.translate('Test AI')}
        </BtnV2>
      }
    >
      <div className={cx(isMobile && 'd-flex align-center gap-xxs')}>
        <span>Manychat AI</span>

        {isMobile && (
          <>
            <Lozenge className="m-l-xxs" type="beta" />

            <Icon.InstagramChannel3 className="text-secondary" size={20} />
          </>
        )}

        {!isMobile && (
          <span className={cm.betaHint}>
            {l.translate('BETA for Instagram')}{' '}
            <Icon.Question
              className={cm.betaHint__help}
              data-title={l.translate(
                'Available in BETA for Instagram only. Responses may not always be perfect and features are limited.',
              )}
              size={16}
            />
          </span>
        )}
      </div>
    </Title>
  )
}
